// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__etofs","col":"styles_col__3MIfy"};